// The feis screens an event-day device can open (card 540f21a4), each with the
// job functions that show it. The paths are the organizer's own screens; the
// device's home lists the ones its job includes, and the device's routes only
// lead to those.
export const FEIS_SCREENS = [
  { key: 'checkin', title: 'Check-in', description: 'Side stage check-in', icon: 'how_to_reg', path: '/check-in', name: true, any: ['feis.checkin.view', 'feis.checkin.mark'] },
  { key: 'tabulate', title: 'Tabulate', description: 'Enter and edit scores', icon: 'edit_note', path: '/tabulate', name: true, any: ['feis.scores.enter'] },
  // the results functions all read the results status (MC review 0699f116)
  {
    key: 'resultStatus',
    title: 'Results Status',
    description: 'Results, publishing and round medals',
    icon: 'fact_check',
    path: '/result-status',
    name: true,
    any: ['feis.results.status', 'feis.results.view', 'feis.roundmedals', 'feis.results.publish', 'feis.results.unpublish'],
  },
  { key: 'published', title: 'Published Results', description: 'Competitions already published', icon: 'task_alt', path: '/published-results', name: true, any: ['feis.results.published'] },
  { key: 'awards', title: 'Awards Table', description: 'Who placed, awards collected', icon: 'military_tech', path: '/awards', name: false, any: ['feis.awards'] },
  {
    key: 'sheets',
    title: 'Score and Check-in Sheets',
    description: 'Print sheets for a competition',
    icon: 'print',
    path: '/score-checkin-download',
    name: true,
    any: ['feis.checkin.sheets', 'feis.scoresheets.print'],
  },
  { key: 'competitors', title: 'Competitor Lists', description: 'Competitors and number cards', icon: 'groups', path: '/competitorss', name: true, any: ['feis.competitors.view', 'feis.cards.print'] },
  // opens the organizer's Add a Competitor window on the home itself
  { key: 'addCompetitor', title: 'Add a Competitor', description: 'Enter a dancer in competitions', icon: 'person_add', modal: 'AddCompetitor', any: ['feis.competitors.edit'] },
  { key: 'editCompetitors', title: 'Edit Competitors', description: 'Change an existing entry', icon: 'person_edit', path: '/edit-competitors', name: true, any: ['feis.competitors.edit'] },
];

// Screens reached from another screen (not on the home), with what opens them.
// Complete Results opens for one competition, from Results Status or
// Published Results (MC review 0699f116 R1-F1), so it isn't on the home.
export const FEIS_INNER_ROUTES = [
  { path: '/edit-register/:name', any: ['feis.competitors.edit'] },
  {
    path: '/complete-results/:name',
    any: ['feis.results.status', 'feis.results.view', 'feis.roundmedals', 'feis.results.publish', 'feis.results.unpublish'],
  },
];

// The link to a screen for this device's event.
export const screenLink = (screen, event) =>
  screen.name
    ? `${screen.path}/${encodeURIComponent(event.name || 'event')}?id=${event._id}`
    : `${screen.path}?id=${event._id}`;
